var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"a-icon a-icon--arrow-right-long",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 9.61"}},[_c('path',{attrs:{"d":"M14.03,0l-1.29,1.24l2.78,2.68H0v1.76h15.52l-2.78,2.68l1.29,1.24L19,4.81L14.03,0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }